import './component.scss'

document.addEventListener('DOMContentLoaded', () => {
  // タブとセクションの設定
  const tabConfig = [
    { tabSelector: '.company-tabbar-sp__tab-examples', containerId: 'company-show-examples' },
    { tabSelector: '.company-tabbar-sp__tab-reviews', containerId: 'company-show-reviews' },
    { tabSelector: '.company-tabbar-sp__tab-features', containerId: 'company-show-features' },
    { tabSelector: '.company-tabbar-sp__tab-company-overview', containerId: 'company-show-overview' }
  ]

  // タブとコンテナを取得
  const tabs = tabConfig.map(config => ({
    tab: document.querySelector(config.tabSelector),
    container: document.querySelector(`#${config.containerId}`),
    scrollId: config.containerId
  }))

  // タブクリック時の挙動を設定
  tabs.forEach(({ tab, scrollId }) => {
    if (tab) {
      tab.addEventListener('click', () => smoothScroll(scrollId))
    }
  })

  // IntersectionObserverが利用可能な場合
  if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

    // 表示されている最初のタブを見つける
    const firstVisible = tabs.find(({ tab }) =>
      tab && !tab.classList.contains('company-tabbar-sp__hidden')
    )

    // 表示されているコンテナのリスト
    const visibleContainers = tabs
      .map(({ container }) => container)
      .filter(container => container !== null)

    // 最初の表示タブをトップタブとして扱う
    if (firstVisible && firstVisible.container) {
      toggleActiveTopTab(visibleContainers, firstVisible.tab)
    }

    // 他のタブの通常のアクティブ状態管理
    tabs.forEach(({ tab, container }) => {
      if (container && tab && tab !== firstVisible?.tab) {
        toggleActiveTab(container, tab)
      }
    })
  }
})

function smoothScroll (id) {
  const tabbarContainer = document.querySelector('.company-tabbar-sp')
  const tabbarHeight = tabbarContainer.offsetHeight
  const totalOffset = tabbarHeight + 64 // スクロールすると追従ヘッダーが被るため位置を調整

  const target = document.getElementById(id)
  if (target) {
    window.scrollTo({
      top: target.offsetTop - totalOffset,
      behavior: 'smooth'
    })
  }
}

// 最初のタブ（工事実績）を監視して、アクティブ状態を切り替える
function toggleActiveTopTab (containers, tab) {
  const targetContainer = containers.find((container) => container !== null)
  if (!targetContainer) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && window.scrollY < targetContainer.offsetTop) {
          tab.classList.add('company-tabbar-sp__active')
        } else {
          tab.classList.remove('company-tabbar-sp__active')
        }
      })
    },
    {
      rootMargin: '0px 0px -100% 0px',
      threshold: 0
    }
  )

  observer.observe(targetContainer)
}

function toggleActiveTab (container, tab) {
  if (!container || !tab) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          tab.classList.add('company-tabbar-sp__active')
        } else {
          tab.classList.remove('company-tabbar-sp__active')
        }
      })
    },
    {
      rootMargin: '0px 0px -100% 0px',
      threshold: 0
    }
  )
  observer.observe(container)
}
